<template>
  <div id="app">
    <router-view />
    <logout-tip v-model="showLogoutTip" />
  </div>
</template>

<script>
  import LogoutTip from '@/components/logout-tip'
  import mqStore from '@/util/mqtt-engine'
  const { createConnect } = mqStore()
  export default {
    name: 'app',
    components: { LogoutTip },
    data() {
      return {}
    },
    computed: {
      showLogoutTip: {
        get() {
          return this.$store.state.user.logoutType === 2 || this.$store.state.user.logoutType === 4
        },
        set() {
          this.$store.commit('SET_LOGOUTTYPE', '')
        }
      }
    },
    created() {
      this.handleSubScribe()
    },
    methods: {
      handleSubScribe() {
        if (this.$store.state.user.token) {
          createConnect()
        }
        // 订阅登录登出消息
        this.$store.dispatch('subScribeLogout', (state) => {
          this.$router.push({ path: '/login' })
        })
      }
    }
  }
</script>
<style lang="scss">
  /* #app {
    width: 100%;
    height: 100%;
    overflow: hidden;
  } */
  .el-radio__inner {
    border: 1px solid #999 !important;
  }
  .el-image-viewer__next,
  .el-image-viewer__prev,
  .el-image-viewer__close {
    background-color: #fff !important;
    margin: 0 20px !important;
    .el-icon-arrow-right,
    .el-icon-arrow-left,
    .el-icon-close {
      color: #333 !important;
      font-weight: 600 !important;
    }
  }
  .el-image-viewer__actions {
    background-color: #fff !important;
    .el-icon-zoom-out,
    .el-icon-zoom-in,
    .el-image-viewer__actions__divider,
    .el-icon-full-screen,
    .el-image-viewer__actions__divider,
    .el-icon-refresh-left,
    .el-icon-refresh-right {
      color: #333 !important;
    }
  }
</style>
